import { SupportActions, SupportState } from '../actions/support/support.types';

import {
  TICKETS_LOADING,
  GET_TICKET_SUCCESS,
  CREATE_TICKET_SUCCESS,
  GET_TICKET_ID_SUCCESS,
  COMMENT_SUCCESS,
  GET_TICKETS_CSV,
  GET_TICKET_FAILURE,
  CREATE_TICKET_FAILURE,
  GET_TICKET_ID_FAILURE,
} from '../actions/support/actions';

export const initialState: SupportState = {
  loading: false,
  tickets: null,
  ticket: null,
  comment: null,
  error: null,
};

const supportReducer = (state = initialState, action: SupportActions) => {
  switch (action.type) {
    case TICKETS_LOADING:
      return { ...state, loading: true };

    case GET_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        tickets: action.payload,
      };

    case CREATE_TICKET_SUCCESS:
      return {
        ...state,
        loading: false,
        ticket: action.payload,
      };

    case GET_TICKET_ID_SUCCESS:
      return {
        ...state,
        loading: false,
        ticket: action.payload,
      };

    case COMMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        comment: action.payload,
      };

    case GET_TICKETS_CSV:
      return { ...state, loading: false };

    case GET_TICKET_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case CREATE_TICKET_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    case GET_TICKET_ID_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default supportReducer;
